module.exports = __webpack_public_path__ + "images/icons_v2/volume-mid-outlined-7150f350.svg";